import React from 'react';
import { PropTypes } from 'prop-types';

import SelectFancy from '@atoms/SelectFancy';
import LoadingArea from '@molecules/LoadingArea';
import useCountryOptions from '@hooks/useCountryOptions';

const SelectCountries = ({ placeholder, name, label = 'Choose a Country', ...rest }) => {
    const { isLoading, data: countries } = useCountryOptions();

    if (!countries) {
        return <LoadingArea />;
    }

    return (
        <SelectFancy
            label={label}
            name={name}
            options={countries}
            isLoading={isLoading}
            placeholder={placeholder}
            {...rest}
        />
    );
};

SelectCountries.propTypes = {
    placeholder: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
};

export default SelectCountries;
